import { Fragment } from 'react';
import Container from '~/components/common/container';
import SliderSection from '~/components/common/slider-section';
import { Translate, useTranslate } from '~/i18n';
import getExperienceSlider from '~/utils/get-experiences-slider';

type SuggestedExperiencesProps = {
   suggestedExp: any;
};

const SuggestedExperiences = ({ suggestedExp }: SuggestedExperiencesProps) => {
   const { lang } = useTranslate();

   return (
      <div className="bg-gray-light">
         <Container>
            {suggestedExp?.length ? (
               <Fragment>
                  <div className="pt-10 pb-20 mt-12">
                     <SliderSection
                        content={getExperienceSlider(lang, suggestedExp)}
                        id="suggested-experiences"
                        loading={false}
                        subtitle={<Translate id="common:similar experiences" />}
                        // color="primary-color"
                     />
                  </div>
               </Fragment>
            ) : null}
         </Container>
      </div>
   );
};

export default SuggestedExperiences;
